import {
  GET_NOMENCLATURES_IN_PROGRESS,
  GET_NOMENCLATURES_SUCCESS,
  GET_NOMENCLATURES_FAIL,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  nomenclatures: undefined,
  inProgress: false,
  error: false,
};

/**
 * Nomenclatures reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function nomenclatures(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_NOMENCLATURES_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_NOMENCLATURES_SUCCESS:
      return {
        ...state,
        nomenclatures: payload.nomenclatures,
        inProgress: false,
      };

    case GET_NOMENCLATURES_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
